// Utility function that converts an object to a x-www-form-urlencoded string
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods/POST
export function toUrlEncoded(data: { [index: string]: any }): string {
  return Object.keys(data)
    .map(key => `${key}=${data[key]}`)
    .join('&');
}
